// extracted by mini-css-extract-plugin
export default {"gradient":"gradient-component_gradient__aoTot","hide":"gradient-component_hide__BkTAy"};